import { getContext, PropTypes } from 'proper-types';
import { branch, compose, withProps, getDisplayName, setDisplayName } from 'recompose';

var withStyleSheetOverrideFromContext = function withStyleSheetOverrideFromContext(Target) {
  return compose(setDisplayName('WithStyleSheetOverrideFromContext'), getContext({
    brandVolume: PropTypes.oneOf(['low', 'regular', 'high']),
    hasTheme: PropTypes.bool
  }), branch(function (_ref) {
    var brandVolume = _ref.brandVolume,
        hasTheme = _ref.hasTheme;
    return brandVolume === 'low' && hasTheme ? true : brandVolume !== 'low' && !hasTheme ? true : !(brandVolume !== 'low' && hasTheme);
  }, compose(getContext({
    getStyleSheet: PropTypes.object
  }), withProps(function (_ref2) {
    var getStyleSheet = _ref2.getStyleSheet;
    return {
      getStyleSheet: getStyleSheet ? getStyleSheet[getDisplayName(Target)] : function () {
        return {};
      }
    };
  }))))(Target);
};

export default withStyleSheetOverrideFromContext;
//# sourceMappingURL=index.js.map